import { useCreateCompanyMutation } from "@/graphql/__generated__/graphql-operations";
import { CreateCompanyDefaultValues, TCreateCompanySchema } from "@/models";
import { UseFormReset } from "react-hook-form";
import { toast } from "react-toastify";


/**
 * Custom hook for creating a company.
 *
 * @param {UseFormReset<TCreateCompanySchema>} reset - Function to reset the form fields.
 * @returns An object containing the createCompanyMutation function, loading state, and error state.
 */
export default function useCreateCompanyMutationHook(reset: UseFormReset<TCreateCompanySchema>) {
  const [createCompanyMutation, { loading, error }] = useCreateCompanyMutation({
    onCompleted(data) {
      if(data.createCompany) {
        toast.success("Successfully created company", {toastId: "createCompanySuccess"});
        // Reset form after successful submission
        reset(CreateCompanyDefaultValues);
      }
    },
    onError(error) {
      toast.error(error.toString(), {toastId: "createCompanyError"});
    }
  });

  return {
    createCompanyMutation,
    loading,
    error
  };
}
